import { __extends, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import omit from 'lodash/omit';
import styles from './styles.css.js';

var TextAreaContainer =
/** @class */
function (_super) {
  __extends(TextAreaContainer, _super);

  function TextAreaContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  TextAreaContainer.prototype.handleChange = function (event) {
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  TextAreaContainer.prototype.componentDidMount = function () {
    this.adjustHeight();
  };

  TextAreaContainer.prototype.componentDidUpdate = function () {
    this.adjustHeight();
  };

  TextAreaContainer.prototype.adjustHeight = function () {
    if (this.el && this.props.expand) {
      this.el.style.height = '0';
      this.el.style.height = this.el.scrollHeight + "px";
    }
  };

  TextAreaContainer.prototype.render = function () {
    var _a, _b, _c;

    var _this = this;

    var _d;

    var _e = this.props,
        className = _e.className,
        label = _e.label,
        placeholder = _e.placeholder,
        loading = _e.loading,
        inputRef = _e.inputRef,
        value = _e.value,
        defaultValue = _e.defaultValue,
        errorText = _e.errorText,
        rows = _e.rows,
        textAreaProps = _e.textAreaProps,
        name = _e.name;
    var hasError = !!errorText;
    var labelClasses = classnames(styles.label, (_a = {}, _a[styles.labelError] = hasError, _a));
    var inputClasses = classnames(styles.textarea, (_b = {}, _b[styles.loading] = loading, _b), (_d = textAreaProps) === null || _d === void 0 ? void 0 : _d.className);
    return React.createElement("label", {
      className: classnames((_c = {}, _c[styles.hasError] = hasError, _c), className)
    }, label && React.createElement("div", {
      className: labelClasses
    }, label), React.createElement("div", {
      className: styles.container
    }, React.createElement("textarea", __assign({
      onChange: this.handleChange,
      placeholder: placeholder,
      className: inputClasses,
      name: name,
      rows: rows,
      ref: function ref(el) {
        if (el) _this.el = el;
        if (inputRef) inputRef(el);
      },
      value: value,
      defaultValue: defaultValue
    }, omit(textAreaProps, 'className')))), errorText && React.createElement("div", {
      className: styles.error
    }, errorText), this.props.successText && React.createElement("div", {
      className: styles.successText
    }, this.props.successText), this.props.helpText && React.createElement("div", {
      className: styles.helpText
    }, this.props.helpText));
  };

  TextAreaContainer.defaultProps = {
    expand: false
  };
  return TextAreaContainer;
}(React.Component);

export default TextAreaContainer;
//# sourceMappingURL=index.js.map
